const AI_SOURCES = [
  ["chatgpt.com", "chatgpt"], ["openai.com", "chatgpt"], ["perplexity.ai", "perplexity"], ["copilot.microsoft.com", "copilot"],
  ["bing.com/chat", "copilot"], ["gemini.google.com", "gemini"], ["claude.ai", "claude"], ["you.com", "you"],
];

const ph = () => (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function" ? window.posthog : null);

export const initAttribution = () => {
  try {
    const ref = document.referrer || "";
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source") || "";
    const hit = AI_SOURCES.find(([host]) => ref.includes(host) || utmSource.includes(host.split(".")[0]));
    const aiSource = hit ? hit[1] : (utmSource.match(/chatgpt|perplexity|copilot|gemini|claude/) || [])[0] || "";
    if (aiSource) sessionStorage.setItem("es_ai_source", aiSource);
    const stored = sessionStorage.getItem("es_ai_source");
    const props = { referrer_host: ref ? new URL(ref).hostname : "direct", ...(stored ? { ai_source: stored } : {}) };
    const register = () => ph()?.register?.(props);
    register();
    setTimeout(register, 1500);
  } catch {
    // attribution is best-effort only
  }
};

export const track = (event, props = {}) => {
  try {
    ph()?.capture(event, { ...props, path: window.location.pathname });
  } catch {
    // analytics must never break the UI
  }
};
